export enum HistoryType {
  ENDPOINT_HISTORY = 'ENDPOINT_HISTORY',
  VEHICULE_CHECK = 'VEHICULE_CHECK',
  INSPECTION_USAGE = 'INSPECTION_USAGE',
}

export type HistoryAdvancedFilter = {
  key?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  groupId?: string;
  companyId?: string;
  branchId?: string;
  clientType?: string;
  progressStatus?: string;
};

export enum EndpointHistoryLocalStorage {
  KEY = 'endpointHistoryFilterKey',
  START_DATE = 'endpointHistoryFilterStartDate',
  END_DATE = 'endpointHistoryFilterEndDate',
  GROUP_ID = 'endpointHistoryFilterGroupId',
  COMPANY_ID = 'endpointHistoryFilterCompanyId',
  BRANCH_ID = 'endpointHistoryFilterBranchId',
  CLIENT_TYPE = 'endpointHistoryFilterClientType',
  CLIENT_FULLNAME = 'endpointHistoryFilterClientFullName',
  PROGRESS_STATUS = 'endpointHistoryFilterProgressStatus',
}

export enum VehiculeCheckLocalStorage {
  KEY = 'vehiculeCheckFilterKey',
  START_DATE = 'vehiculeCheckFilterStartDate',
  END_DATE = 'vehiculeCheckFilterEndDate',
  GROUP_ID = 'vehiculeCheckFilterGroupId',
  COMPANY_ID = 'vehiculeCheckFilterCompanyId',
  BRANCH_ID = 'vehiculeCheckFilterBranchId',
  CLIENT_TYPE = 'vehiculeCheckFilterClientType',
  CLIENT_FULLNAME = 'vehiculeCheckFilterClientFullName',
  PROGRESS_STATUS = 'vehiculeCheckFilterProgressStatus',
}

export enum InspectionUsageLocalStorage {
  KEY = 'inspectionUsageFilterKey',
  START_DATE = 'inspectionUsageFilterStartDate',
  END_DATE = 'inspectionUsageFilterEndDate',
  GROUP_ID = 'inspectionUsageFilterGroupId',
  COMPANY_ID = 'inspectionUsageFilterCompanyId',
  BRANCH_ID = 'inspectionUsageFilterBranchId',
  CLIENT_TYPE = 'inspectionUsageFilterClientType',
  CLIENT_FULLNAME = 'inspectionUsageFilterClientFullName',
  PROGRESS_STATUS = 'inspectionUsageFilterProgressStatus',
}